export function printEstorno(idSale) {
  const token = localStorage.getItem("token");
  estornoSale(token, idSale)
}

function estornoSale(token, idSale) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/reports/comprovanteEstorno/${idSale}?auth=${token}`
  );
}